export const ONE_DAY = '1day'
export const ONE_WEEK = '1week'
export const ONE_MONTH = '1month'
export const THREE_MONTH = '3months'
export const YTD = 'ytd'
export const ONE_YEAR = '1year'

export const TIME_PERIOD_MAP = Object.freeze({
  [ONE_DAY]: '1天',
  [ONE_WEEK]: '1周',
  [ONE_MONTH]: '1月',
  [THREE_MONTH]: '3月',
  [YTD]: 'YTD',
  [ONE_YEAR]: '1年',
})
